import api from './api';

export const getBookmarks = () => api.get('/bookmarks');
export const toggleBookmark = (lessonId) => api.post(`/bookmarks/${lessonId}`);